import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsDetailCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-family/detail';

const ResearchFamilyNotificationsDetailCivilStatusOtherPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsDetailCivilStatusShared isOther />
    </Fragment>
  );
};

ResearchFamilyNotificationsDetailCivilStatusOtherPage.displayName =
  'Research Family Notifications CivilStatusOtherPage component';

export default ResearchFamilyNotificationsDetailCivilStatusOtherPage;
